import { Controller as StimulusController } from 'stimulus';
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  Lazy,
  Thumbs,
} from 'swiper';
import getControllerForElement from '../helpers/getControllerForElement';

class SliderController extends StimulusController {
  connect() {
    SwiperCore.use([Navigation, Pagination, EffectFade, Lazy, Thumbs]);

    this.swiper = new SwiperCore(this.element, {
      ...this.sliderOptionsFromElement(),

      navigation: {
        prevEl: this.hasPrevTarget ? this.prevTarget : null,
        nextEl: this.hasNextTarget ? this.nextTarget : null,
      },

      pagination: {
        el: this.hasPaginationTarget ? this.paginationTarget : null,
        type: 'bullets',
      },

      thumbs: {
        swiper: null,
        multipleActiveThumbs: false,
        slideThumbActiveClass: 'swiper-slide-active',
      },

      lazy: {
        preloaderClass: 'swiper__loader',
      },
    });

    if (this.data.has('thumbs') && this.data.get('thumbs')) {
      this.useThumbs();
    }

    if (this.data.has('dynamic-caption') && this.data.get('dynamic-caption')) {
      this.useCaptions();
    }
  }

  sliderOptionsFromElement() {
    const options = this.element.dataset;
    const config = {};

    if (typeof options === 'undefined') {
      return config;
    }

    Object.keys(options).forEach((option) => {
      const regex = new RegExp('^slider', 'g');

      if (!regex.test(option)) {
        return;
      }

      // Transform the key from 'sliderArrows' to 'Arrows'
      let value = options[option];
      let transformedOption = option.replace('slider', '');

      // Lowercase the first character ('Arrows' => 'arrows')
      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }

      config[transformedOption] = transformedOption === 'breakpoints'
        ? JSON.parse(value)
        : value;
    });

    return config;
  }

  useCaptions() {
    if (!this.hasCaptionTarget) return;

    this.swiper.on('slideChange', ({ activeIndex, slides }) => {
      const currentSlide = slides[activeIndex];
      const mediaItem = currentSlide.querySelector('img');

      this.outputCaption(mediaItem.alt);
    });
  }

  useThumbs() {
    const controlsEl = document.querySelector(this.data.get('thumbs'));

    getControllerForElement(this.application, controlsEl, 'slider')
      .then((controller) => {
        this.swiper.thumbs.swiper = controller.swiper;

        this.swiper.thumbs.swiper.on('click', (swiper, e) => {
          if (e.target.tagName !== 'IMG') return;

          this.swiper.slideTo(swiper.clickedIndex + 1);
        });

        this.swiper.thumbs.swiper.init();
      });
  }

  outputCaption(caption) {
    this.captionTarget.innerText = caption;
  }
}

SliderController.targets = [
  'prev',
  'next',
  'caption',
  'pagination',
];

export default SliderController;
